<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">Add Courtsey Groups</div>
    </div>
    <div class="white-wrapper" style="zoom: 0.9">
      <form class="row">
        <div class="col-lg-4 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                v-model="group_name"
                type="text"
                name="group_name"
                id="group_name"
              />
              <label>Group Name</label>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                v-model="group_desc"
                type="text"
                name="group_desc"
                id="group_desc"
              />
              <label>Description</label>
            </div>
          </div>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            @click.prevent.stop="OnFinalSubmit(true)"
            class="btn-blue"
          >
            {{ $t("save") }}
          </button>
          <button
            :disabled="btenable"
            @click.prevent.stop="OnFinalSubmit(false)"
            class="btn-blue"
          >
            {{ $t("saveaddmore") }}
          </button>
          <button @click.prevent.stop="resetForm()" class="btn-black">
            {{ $t("reset") }}
          </button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="courtsey-groups"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MarketingService from "@/services/MarketingService";

export default {
  data() {
    return {
      btenable: false,
      group_name: "",
      group_desc: "",
      cg_is_active: "Y",
      submitted: false,
    };
  },
  mounted() {},
  methods: {
    OnFinalSubmit: function (redirect) {
      this.submitted = true;
      if (!this.group_name) {
        return this.$toasted.show("Please Enter Group Name");
      } else {
        let payload = {
          group_name: this.group_name,
          group_desc: this.group_desc,
          cg_is_active: "Y",
        };
        MarketingService.AddCourtseyGroups(payload)
          .then((response) => {
            this.btenable = false;
            const { data } = response;
            if (data && data.status) {
              this.resetForm();
              if (redirect) {
                this.$router.push({
                  path: "courtsey-groups",
                });
              }
              this.submitted = false;
              this.$toasted.show(data.message);
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((err) => {
            console.log("Error:", err);
          });
      }
    },
    resetForm: function () {
      this.group_name = "";
      this.group_desc = "";
      this.cg_is_active = "Y";
      this.btenable = false;
      this.submitted = false;
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/CourtseyComponents/CourtseyGroups/addGroups.vue